const translations = {
  en: {
    code: "en",
    label: "English",
    flag: "https://flagcdn.com/w40/us.png",
    nav: {
      home: "Home",
      portfolio: "Portfolio",
      about: "About Me",
      testimonials: "Testimonials",
    },
    hero: {
      greeting: "Hi, I'm Jihad Zaidan",
      buildAs: "I build as a",
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum, quas. Amet soluta assumenda cum?",
      cta: "Get In Touch",
      downloadCv: "Download CV",
      roles: ["Robotics Developer", "Front End Developer", "Back End Developer"],
    },
    skills: {
      label: "My Skills",
      heading: "My Expertise",
      categoryFilter: "Category",
      categoryOptions: {
        "UI/UX": "UI/UX",
        "Front-End": "Front-End",
        "Back-End": "Back-End",
        Mobile: "Mobile",
        Database: "Database",
        "Lain-lain": "Others",
      },
    },
    about: {
      label: "About",
      heading: "About Me",
      p1: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum sed veniam quasi dicta accusamus recusandae? Voluptatem, reprehenderit alias? Eligendi aperiam tempora numquam sint odit optio.",
      p2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum sed veniam quasi dicta accusamus recusandae?",
    },
    experience: {
      label: "Experience",
      heading: "My Experience",
      items: [
        {
          tag: "School",
          title: "SMK Negeri 4 Malang",
          place: "Full Stack Developer",
          year: "2023 – 2026",
          description: "Studied software engineering, covering web development, databases, and programming fundamentals.",
        },
        {
          tag: "Internship (PKL)",
          title: "Sekretariat Presiden Republik Indonesia",
          place: "Live Stream Operator",
          year: "2025 - 2026",
          description: "Completed a one-year PKL internship as a Live Stream Operator on YouTube channel Sekretariat Presiden, handling official live broadcast operations in a professional environment.",
        },
      ],
    },
    portfolio: {
      label: "Recent Projects",
      heading: "My Portfolio",
      project: "Project",
      filterButton: "Filter",
      positionFilter: "Position",
      techFilter: "Technology",
      allFilter: "All",
      clearFilter: "Reset",
      filterSummary: "Active:",
      emptyFilter: "No projects match the selected filters.",
    },
    testimonials: {
      label: "Clients Feedback",
      heading: "Testimonials",
    },
    footer: {
      copyright: "© 2024 Muhammad Jihad Zaidan. All Rights Reserved.",
      contactLabel: "My Contact & Media Social",
    },
  },

  id: {
    code: "id",
    label: "Indonesia",
    flag: "https://flagcdn.com/w40/id.png",
    nav: {
      home: "Beranda",
      portfolio: "Portofolio",
      about: "Tentang Saya",
      testimonials: "Testimoni",
    },
    hero: {
      greeting: "Hai, Saya Jihad Zaidan",
      buildAs: "Saya membangun sebagai",
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum, quas. Amet soluta assumenda cum?",
      cta: "Hubungi Saya",
      downloadCv: "Unduh CV",
      roles: ["Robotics Developer", "Front End Developer", "Back End Developer"],
    },
    skills: {
      label: "Keahlian Saya",
      heading: "Bidang Keahlian",
      categoryFilter: "Kategori",
      categoryOptions: {
        "UI/UX": "UI/UX",
        "Front-End": "Front-End",
        "Back-End": "Back-End",
        Mobile: "Mobile",
        Database: "Database",
        "Lain-lain": "Lain-lain",
      },
    },
    about: {
      label: "Tentang",
      heading: "Tentang Saya",
      p1: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum sed veniam quasi dicta accusamus recusandae? Voluptatem, reprehenderit alias? Eligendi aperiam tempora numquam sint odit optio.",
      p2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum sed veniam quasi dicta accusamus recusandae?",
    },
    experience: {
      label: "Pengalaman",
      heading: "Pengalaman Saya",
      items: [
        {
          tag: "Sekolah",
          title: "SMK Negeri 4 Malang",
          place: "Full Stack Developer",
          year: "2023 – 2026",
          description: "Mempelajari rekayasa perangkat lunak, meliputi pengembangan web, basis data, dan dasar-dasar pemrograman.",
        },
        {
          tag: "PKL",
          title: "Sekretariat Presiden Republik Indonesia",
          place: "Operator Live Stream",
          year: "2025 – 2026",
          description: "Menjalani PKL selama satu tahun sebagai Operator Live Stream di YouTube channel Sekretariat Presiden, dengan tanggung jawab operasional siaran langsung resmi secara profesional.",
        },
      ],
    },
    portfolio: {
      label: "Proyek Terbaru",
      heading: "Portofolio Saya",
      project: "Proyek",
      filterButton: "Filter",
      positionFilter: "Posisi",
      techFilter: "Teknologi",
      allFilter: "Semua",
      clearFilter: "Reset",
      filterSummary: "Aktif:",
      emptyFilter: "Tidak ada proyek yang cocok dengan filter.",
    },
    testimonials: {
      label: "Ulasan Klien",
      heading: "Ulasan Pelanggan",
    },
    footer: {
      copyright: "© 2024 Muhammad Jihad Zaidan. Hak Cipta Dilindungi.",
      contactLabel: "Kontak & Media Sosial Saya",
    },
  },

  fr: {
    code: "fr",
    label: "Francais",
    flag: "https://flagcdn.com/w40/fr.png",
    nav: {
      home: "Accueil",
      portfolio: "Portfolio",
      about: "A propos",
      testimonials: "Temoignages",
    },
    hero: {
      greeting: "Salut, je suis Jihad Zaidan",
      buildAs: "Je developpe en tant que",
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum, quas. Amet soluta assumenda cum?",
      cta: "Me Contacter",
      downloadCv: "Telecharger le CV",
      roles: ["Robotics Developer", "Front End Developer", "Back End Developer"],
    },
    skills: {
      label: "Mes Competences",
      heading: "Mon Expertise",
      categoryFilter: "Categorie",
      categoryOptions: {
        "UI/UX": "UI/UX",
        "Front-End": "Front-End",
        "Back-End": "Back-End",
        Mobile: "Mobile",
        Database: "Base de donnees",
        "Lain-lain": "Autres",
      },
    },
    about: {
      label: "A propos",
      heading: "A propos de moi",
      p1: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum sed veniam quasi dicta accusamus recusandae? Voluptatem, reprehenderit alias? Eligendi aperiam tempora numquam sint odit optio.",
      p2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum sed veniam quasi dicta accusamus recusandae?",
    },
    experience: {
      label: "Expérience",
      heading: "Mon Expérience",
      items: [
        {
          tag: "École",
          title: "SMK Negeri 4 Malang",
          place: "Développeur Full Stack",
          year: "2023 – 2026",
          description: "Étude du développement logiciel couvrant le développement web, les bases de données et la programmation.",
        },
        {
          tag: "Stage (PKL)",
          title: "Sekretariat Presiden Republik Indonesia",
          place: "Operateur Live Stream",
          year: "2025 – 2026",
          description: "A effectue un stage PKL d'un an en tant qu'Operateur Live Stream sur YouTube channel Sekretariat Presiden, en assurant de maniere professionnelle les operations de diffusion en direct officielles.",
        },
      ],
    },
    portfolio: {
      label: "Projets Recents",
      heading: "Mon Portfolio",
      project: "Projet",
      filterButton: "Filtrer",
      positionFilter: "Poste",
      techFilter: "Technologie",
      allFilter: "Tous",
      clearFilter: "Reinitialiser",
      filterSummary: "Actif :",
      emptyFilter: "Aucun projet ne correspond aux filtres selectionnes.",
    },
    testimonials: {
      label: "Avis Clients",
      heading: "Retours Clients",
    },
    footer: {
      copyright: "© 2024 Muhammad Jihad Zaidan. Tous droits reserves.",
      contactLabel: "Mon Contact & Réseaux Sociaux",
    },
  },

  es: {
    code: "es",
    label: "Espanol",
    flag: "https://flagcdn.com/w40/es.png",
    nav: {
      home: "Inicio",
      portfolio: "Portafolio",
      about: "Sobre Mi",
      testimonials: "Testimonios",
    },
    hero: {
      greeting: "Hola, soy Jihad Zaidan",
      buildAs: "Desarrollo como",
      description: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum, quas. Amet soluta assumenda cum?",
      cta: "Contactame",
      downloadCv: "Descargar CV",
      roles: ["Robotics Developer", "Front End Developer", "Back End Developer"],
    },
    skills: {
      label: "Mis Habilidades",
      heading: "Mi Experiencia",
      categoryFilter: "Categoria",
      categoryOptions: {
        "UI/UX": "UI/UX",
        "Front-End": "Front-End",
        "Back-End": "Back-End",
        Mobile: "Movil",
        Database: "Base de datos",
        "Lain-lain": "Otros",
      },
    },
    about: {
      label: "Sobre Mi",
      heading: "Acerca de Mi",
      p1: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum sed veniam quasi dicta accusamus recusandae? Voluptatem, reprehenderit alias? Eligendi aperiam tempora numquam sint odit optio.",
      p2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum sed veniam quasi dicta accusamus recusandae?",
    },
    experience: {
      label: "Experiencia",
      heading: "Mi Experiencia",
      items: [
        {
          tag: "Escuela",
          title: "SMK Negeri 4 Malang",
          place: "Desarrollador Full Stack",
          year: "2023 – 2026",
          description: "Estudios de ingeniería de software cubriendo desarrollo web, bases de datos y fundamentos de programación.",
        },
        {
          tag: "Prácticas (PKL)",
          title: "Sekretariat Presiden Republik Indonesia",
          place: "Operador de Live Stream",
          year: "2025 – 2026",
          description: "Realice una pasantia PKL de un ano como Operador de Live Stream en YouTube channel Sekretariat Presiden, gestionando de forma profesional las operaciones de transmision oficial en vivo.",
        },
      ],
    },
    portfolio: {
      label: "Proyectos Recientes",
      heading: "Mi Portafolio",
      project: "Proyecto",
      filterButton: "Filtrar",
      positionFilter: "Posicion",
      techFilter: "Tecnologia",
      allFilter: "Todos",
      clearFilter: "Restablecer",
      filterSummary: "Activos:",
      emptyFilter: "Ningun proyecto coincide con los filtros seleccionados.",
    },
    testimonials: {
      label: "Resenas de Clientes",
      heading: "Opiniones de Clientes",
    },
    footer: {
      copyright: "© 2024 Muhammad Jihad Zaidan. Todos los derechos reservados.",
      contactLabel: "Mi Contacto & Redes Sociales",
    },
  },

  ar: {
    code: "ar",
    label: "العربية",
    flag: "https://flagcdn.com/w40/sa.png",
    dir: "rtl",
    nav: {
      home: "الرئيسية",
      portfolio: "أعمالي",
      about: "عني",
      testimonials: "التوصيات",
    },
    hero: {
      greeting: "مرحباً، أنا جهاد زيدان",
      buildAs: "أعمل كـ",
      description: "لوريم إيبسوم دولور سيت أميت، كونسيكتيتور أديبيسينج إليت.",
      cta: "تواصل معي",
      downloadCv: "تحميل السيرة الذاتية",
      roles: ["Robotics Developer", "Front End Developer", "Back End Developer"],
    },
    skills: {
      label: "مهاراتي",
      heading: "خبراتي",
      categoryFilter: "الفئة",
      categoryOptions: {
        "UI/UX": "واجهة وتجربة المستخدم",
        "Front-End": "الواجهة الامامية",
        "Back-End": "الواجهة الخلفية",
        Mobile: "تطبيقات الجوال",
        Database: "قواعد البيانات",
        "Lain-lain": "اخرى",
      },
    },
    about: {
      label: "نبذة",
      heading: "عني",
      p1: "لوريم إيبسوم دولور سيت أميت، كونسيكتيتور أديبيسينج إليت. أوتيم أوفيسيس سيت ديبيتيس أومنيس هاروم.",
      p2: "لوريم إيبسوم دولور سيت أميت، كونسيكتيتور أديبيسينج إليت.",
    },
    experience: {
      label: "الخبرة",
      heading: "خبرتي",
      items: [
        {
          tag: "المدرسة",
          title: "SMK Negeri 4 Malang",
          place: "مطور Full Stack",
          year: "2023 – 2026",
          description: "دراسة هندسة البرمجيات تشمل تطوير الويب وقواعد البيانات وأساسيات البرمجة.",
        },
        {
          tag: "التدريب الميداني (PKL)",
          title: "Sekretariat Presiden Republik Indonesia",
          place: "مشغل البث المباشر",
          year: "2025 – 2026",
          description: "أكملت تدريب PKL لمدة عام كامل بصفتي مشغل بث مباشر على YouTube channel Sekretariat Presiden، مع إدارة عمليات البث الرسمي المباشر باحترافية.",
        },
      ],
    },
    portfolio: {
      label: "أحدث المشاريع",
      heading: "أعمالي",
      project: "مشروع",
      filterButton: "تصفية",
      positionFilter: "المنصب",
      techFilter: "التقنية",
      allFilter: "الكل",
      clearFilter: "إعادة تعيين",
      filterSummary: "النشط:",
      emptyFilter: "لا توجد مشاريع مطابقة للفلاتر المحددة.",
    },
    testimonials: {
      label: "آراء العملاء",
      heading: "تقييمات العملاء",
    },
    footer: {
      copyright: "© 2024 Muhammad Jihad Zaidan. جميع الحقوق محفوظة.",
      contactLabel: "اتصالي و وسائل التواصل الاجتماعي",
    },
  },

  ja: {
    code: "ja",
    label: "日本語",
    flag: "https://flagcdn.com/w40/jp.png",
    nav: {
      home: "ホーム",
      portfolio: "ポートフォリオ",
      about: "自己紹介",
      testimonials: "お客様の声",
    },
    hero: {
      greeting: "こんにちは、ジハド・ザイダンです",
      buildAs: "私は次として開発します",
      description: "ロレム・イプサム・ドロル・シット・アメット、コンセクテトゥル・アジピシング・エリット。",
      cta: "お問い合わせ",
      downloadCv: "CVをダウンロード",
      roles: ["Robotics Developer", "Front End Developer", "Back End Developer"],
    },
    skills: {
      label: "スキル",
      heading: "得意分野",
      categoryFilter: "カテゴリ",
      categoryOptions: {
        "UI/UX": "UI/UX",
        "Front-End": "フロントエンド",
        "Back-End": "バックエンド",
        Mobile: "モバイル",
        Database: "データベース",
        "Lain-lain": "その他",
      },
    },
    about: {
      label: "自己紹介",
      heading: "私について",
      p1: "ロレム・イプサム・ドロル・シット・アメット、コンセクテトゥル・アジピシング・エリット。アウテム・オフィシス・シット・デビティス・オムニス・ハルム。",
      p2: "ロレム・イプサム・ドロル・シット・アメット、コンセクテトゥル・アジピシング・エリット。",
    },
    experience: {
      label: "経歴",
      heading: "私の経歴",
      items: [
        {
          tag: "学校",
          title: "SMK Negeri 4 Malang",
          place: "フルスタック開発者",
          year: "2023 – 2026",
          description: "Web開発、データベース、プログラミングの基礎を含むソフトウェアエンジニアリングを学びました。",
        },
        {
          tag: "インターンシップ (PKL)",
          title: "Sekretariat Presiden Republik Indonesia",
          place: "ライブストリームオペレーター",
          year: "2025 – 2026",
          description: "YouTube channel Sekretariat Presidenにおいて、公式ライブ配信業務を専門的に担当するライブストリームオペレーターとして、1年間のPKLインターンシップを務めました。",
        },
      ],
    },
    portfolio: {
      label: "最近のプロジェクト",
      heading: "ポートフォリオ",
      project: "プロジェクト",
      filterButton: "フィルター",
      positionFilter: "ポジション",
      techFilter: "技術",
      allFilter: "すべて",
      clearFilter: "リセット",
      filterSummary: "適用中:",
      emptyFilter: "選択したフィルターに一致するプロジェクトはありません。",
    },
    testimonials: {
      label: "クライアントの声",
      heading: "お客様の評価",
    },
    footer: {
      copyright: "© 2024 Muhammad Jihad Zaidan. All Rights Reserved.",
      contactLabel: "私の連絡先とソーシャルメディア",
    },
  },

  zh: {
    code: "zh",
    label: "中文",
    flag: "https://flagcdn.com/w40/cn.png",
    nav: {
      home: "首页",
      portfolio: "作品集",
      about: "关于我",
      testimonials: "客户评价",
    },
    hero: {
      greeting: "你好，我是Jihad Zaidan",
      buildAs: "我从事",
      description: "Lorem ipsum dolor sit amet，consectetur adipiscing elit。",
      cta: "联系我",
      downloadCv: "下载简历",
      roles: ["Robotics Developer", "Front End Developer", "Back End Developer"],
    },
    skills: {
      label: "我的技能",
      heading: "专业领域",
      categoryFilter: "分类",
      categoryOptions: {
        "UI/UX": "UI/UX",
        "Front-End": "前端",
        "Back-End": "后端",
        Mobile: "移动端",
        Database: "数据库",
        "Lain-lain": "其他",
      },
    },
    about: {
      label: "关于",
      heading: "关于我",
      p1: "Lorem ipsum dolor sit amet consectetur adipiscing elit. Autem officiis sit debitis omnis harum.",
      p2: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    experience: {
      label: "经历",
      heading: "我的经历",
      items: [
        {
          tag: "学校",
          title: "SMK Negeri 4 Malang",
          place: "全栈开发者",
          year: "2023 – 2026",
          description: "学习软件工程，涵盖网页开发、数据库和编程基础知识。",
        },
        {
          tag: "实习 (PKL)",
          title: "Sekretariat Presiden Republik Indonesia",
          place: "直播运营员",
          year: "2025 – 2026",
          description: "我在YouTube channel Sekretariat Presiden担任直播运营员，完成了为期一年的PKL实习，并以专业标准负责官方直播运营工作。",
        },
      ],
    },
    portfolio: {
      label: "近期项目",
      heading: "我的作品集",
      project: "项目",
      filterButton: "筛选",
      positionFilter: "职位",
      techFilter: "技术",
      allFilter: "全部",
      clearFilter: "重置",
      filterSummary: "已启用:",
      emptyFilter: "没有项目符合所选筛选条件。",
    },
    testimonials: {
      label: "客户反馈",
      heading: "客户评价",
    },
    footer: {
      copyright: "© 2024 Muhammad Jihad Zaidan. 版权所有。",
      contactLabel: "我的联系方式和社交媒体",
    },
  },

  ko: {
    code: "ko",
    label: "한국어",
    flag: "https://flagcdn.com/w40/kr.png",
    nav: {
      home: "홈",
      portfolio: "포트폴리오",
      about: "소개",
      testimonials: "추천사",
    },
    hero: {
      greeting: "안녕하세요, 저는 Jihad Zaidan입니다",
      buildAs: "저는 다음으로 개발합니다",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
      cta: "연락하기",
      downloadCv: "이력서 다운로드",
      roles: ["Robotics Developer", "Front End Developer", "Back End Developer"],
    },
    skills: {
      label: "나의 기술",
      heading: "전문 분야",
      categoryFilter: "카테고리",
      categoryOptions: {
        "UI/UX": "UI/UX",
        "Front-End": "프론트엔드",
        "Back-End": "백엔드",
        Mobile: "모바일",
        Database: "데이터베이스",
        "Lain-lain": "기타",
      },
    },
    about: {
      label: "소개",
      heading: "저에 대하여",
      p1: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum.",
      p2: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    },
    experience: {
      label: "경력",
      heading: "나의 경력",
      items: [
        {
          tag: "학교",
          title: "SMK Negeri 4 Malang",
          place: "풀스택 개발자",
          year: "2023 – 2026",
          description: "웹 개발, 데이터베이스, 프로그래밍 기초를 포함한 소프트웨어 공학을 배웠습니다.",
        },
        {
          tag: "인턴십 (PKL)",
          title: "Sekretariat Presiden Republik Indonesia",
          place: "라이브 스트림 오퍼레이터",
          year: "2025 – 2026",
          description: "YouTube channel Sekretariat Presiden에서 라이브 스트림 오퍼레이터로 1년간 PKL 인턴십을 수행하며, 공식 라이브 방송 운영 업무를 전문적으로 담당했습니다.",
        },
      ],
    },
    portfolio: {
      label: "최근 프로젝트",
      heading: "포트폴리오",
      project: "프로젝트",
      filterButton: "필터",
      positionFilter: "포지션",
      techFilter: "기술",
      allFilter: "전체",
      clearFilter: "초기화",
      filterSummary: "활성:",
      emptyFilter: "선택한 필터와 일치하는 프로젝트가 없습니다.",
    },
    testimonials: {
      label: "고객 피드백",
      heading: "고객 평가",
    },
    footer: {
      copyright: "© 2024 Muhammad Jihad Zaidan. All Rights Reserved.",
      contactLabel: "내 연락처 및 소셜 미디어",
    },
  },

  ru: {
    code: "ru",
    label: "Русский",
    flag: "https://flagcdn.com/w40/ru.png",
    nav: {
      home: "Главная",
      portfolio: "Портфолио",
      about: "Обо мне",
      testimonials: "Отзывы",
    },
    hero: {
      greeting: "Привет, я Jihad Zaidan",
      buildAs: "Я разрабатываю как",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      cta: "Связаться",
      downloadCv: "Скачать CV",
      roles: ["Robotics Developer", "Front End Developer", "Back End Developer"],
    },
    skills: {
      label: "Мои навыки",
      heading: "Моя экспертиза",
      categoryFilter: "Категория",
      categoryOptions: {
        "UI/UX": "UI/UX",
        "Front-End": "Фронтенд",
        "Back-End": "Бэкенд",
        Mobile: "Мобильная разработка",
        Database: "База данных",
        "Lain-lain": "Другое",
      },
    },
    about: {
      label: "Обо мне",
      heading: "О себе",
      p1: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem officiis sit debitis omnis harum.",
      p2: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    },
    experience: {
      label: "Опыт",
      heading: "Мой опыт",
      items: [
        {
          tag: "Школа",
          title: "SMK Negeri 4 Malang",
          place: "Full Stack разработчик",
          year: "2023 – 2026",
          description: "Изучал разработку программного обеспечения: веб-разработка, базы данных, основы программирования.",
        },
        {
          tag: "Стажировка (PKL)",
          title: "Sekretariat Presiden Republik Indonesia",
          place: "Оператор Live Stream",
          year: "2025 – 2026",
          description: "Прошел годовую стажировку PKL в должности Оператора Live Stream на YouTube channel Sekretariat Presiden, профессионально обеспечивая операционные процессы официальных прямых трансляций.",
        },
      ],
    },
    portfolio: {
      label: "Последние проекты",
      heading: "Моё портфолио",
      project: "Проект",
      filterButton: "Фильтр",
      positionFilter: "Позиция",
      techFilter: "Технология",
      allFilter: "Все",
      clearFilter: "Сброс",
      filterSummary: "Активно:",
      emptyFilter: "Нет проектов, соответствующих выбранным фильтрам.",
    },
    testimonials: {
      label: "Отзывы клиентов",
      heading: "Отзывы",
    },
    footer: {
      copyright: "© 2024 Muhammad Jihad Zaidan. Все права защищены.",
      contactLabel: "Мои контакты и социальные сети",
    },
  },
};

export default translations;
